import { Card, Container, Row, Col, Button, Badge } from 'react-bootstrap';
import { FaFlask, FaListCheck } from 'react-icons/fa6';
import { useApp } from 'common/AppContext';
import { Link } from 'react-router-dom';

export const Home = () => {

    const { env, user } = useApp();

    return (

        <Container className="py-4">

            <div className="d-flex align-items-baseline gap-2 mb-1">
                <h2 className="m-0">
                    GMetrix Quality Assurance Hub
                </h2>
                {env && env !== 'production' && (
                    <Badge pill bg="secondary">
                        {env}
                    </Badge>
                )}
            </div>

            <p className="text-muted">
                {user?.displayName ? `Welcome back, ${user.displayName}. ` : ''}
                Centralized tooling for the QA team — AI-driven feature testing and TestRail integration in one place.
            </p>

            <Row className="g-3 mt-2">

                <Col md={6}>
                    <Card className="h-100 shadow-sm border-0">
                        <Card.Body className="d-flex flex-column">
                            <div className="d-flex align-items-center gap-2 mb-2">
                                <FaFlask className="text-primary" size={22} />
                                <Card.Title className="m-0">
                                    Feature Tester
                                </Card.Title>
                            </div>
                            <Card.Text className="flex-grow-1">
                                Run an AI-driven functional test against a target site. Submit a URL, optional
                                credentials, and a test plan; approve each step the AI proposes, then review a
                                visual evidence trail.
                            </Card.Text>
                            <div>
                                <Button as={Link} to="/feature-tester" variant="primary">
                                    Open Feature Tester
                                </Button>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                <Col md={6}>
                    <Card className="h-100 shadow-sm border-0">
                        <Card.Body className="d-flex flex-column">
                            <div className="d-flex align-items-center gap-2 mb-2">
                                <FaListCheck className="text-primary" size={22} />
                                <Card.Title className="m-0">
                                    TestRail
                                </Card.Title>
                            </div>
                            <Card.Text className="flex-grow-1">
                                Browse open test runs and create new test cases without leaving the Quality Assurance Hub.
                            </Card.Text>
                            <div className="d-flex gap-2">
                                <Button as={Link} to="/testrail/runs" variant="outline-primary">
                                    Open Test Runs
                                </Button>
                                <Button as={Link} to="/testrail/cases/new" variant="outline-primary">
                                    New Test Case
                                </Button>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

            </Row>

        </Container>

    );

};
